import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import { getisLoggedIn, getinfoUser, signOut, hydrateUserData } from "./libs/redux/slices/Loginxxx/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDataInfoUserMutation } from "./libs/redux/slices/Loginxxx/loginApiSlice";
import WindowPdfViewer from './components/Trkgfile/WindowPdfViewer';
import WindowEmlViewer from './components/Trkgfile/WindowEmlViewer';
import Loadingx from "./components/Loadingx/Loadingx";
/*
*Componente principal de la aplicacion
**/
function App() {
  const isLoggedIn = useSelector(getisLoggedIn);
  const infoUser = useSelector(getinfoUser);
  const dispatch = useDispatch();
  const [loadUserInfo] = useDataInfoUserMutation();
  const [isHydrating, setIsHydrating] = useState(false);

  useEffect(() => {
    if (isLoggedIn && !infoUser) {
      setIsHydrating(true);
      loadUserInfo()
        .unwrap()
        .then((response) => {
          const userData = response?.data?.[0];
          if (userData?.INFOUSER) {
            dispatch(hydrateUserData({ INFOUSER: userData.INFOUSER }));
          }
        })
        .catch((error) => {
          console.error('Error cargando datos de usuario:', error);
        })
        .finally(() => {
          setIsHydrating(false);
        });
    }
  }, [isLoggedIn, infoUser, loadUserInfo, dispatch]);

  useEffect(() => {
    const handleTabClose = (event) => {
      event.preventDefault();
      if (!isLoggedIn) {
        dispatch(signOut());
      }
    };
    window.addEventListener("beforeunload", handleTabClose);
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [dispatch, isLoggedIn]);
  
  if (isHydrating) {
    return <Loadingx />;
  }
  
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={isLoggedIn ? <Navigate to="/home" /> : <Navigate to="/login" />} />
        <Route path="login" element={!isLoggedIn ? <LoginPage /> : <Navigate to="/" />} />
        <Route path="home" element={isLoggedIn ? <HomePage /> : <Navigate to="/" />}></Route>
        <Route path="/home/:id" element={<HomePage />}></Route>
        <Route path="/home/:id/:user" element={<HomePage />}></Route>
        <Route path="/visor/:url" element={<WindowPdfViewer />} />
        <Route path="/visoreml/:url" element={<WindowEmlViewer />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
